import { Routes } from '@angular/router';
import { environment } from './app.environment';
import { embeddedRoutes, siofokRoutes, standardRoutes, ticketRoutes } from './app.routes';
import { embeddedSsrRoutes, siofokSsrRoutes, standardSsrRoutes, ticketSsrRoutes } from './app.ssr';
import { embeddedQueueFairRoutes, siofokQueueFairRoutes, standardQueueFairRoutes, ticketQueueFairRoutes } from './app.queue-fair';

export interface AppFlavor {
  name: string,
  routes: Routes,
  ssrRoutes: string[],
  queueFairRoutes: string[],
  eventRoutePrefix: string,
  businessRoutePrefix: string,
}

const flavors = new Map<'standard' | 'tickets' | 'siofok' | 'embedded', AppFlavor>([
  [
    'standard',
    {
      name: 'standard',
      routes: standardRoutes,
      ssrRoutes: standardSsrRoutes,
      queueFairRoutes: standardQueueFairRoutes,
      eventRoutePrefix: '/e/',
      businessRoutePrefix: '/b/',
    }
  ],
  [
    'tickets',
    {
      name: 'tickets',
      routes: ticketRoutes,
      ssrRoutes: ticketSsrRoutes,
      queueFairRoutes: ticketQueueFairRoutes,
      eventRoutePrefix: '/',
      businessRoutePrefix: '/',
    }
  ],
  [
    'siofok',
    {
      name: 'siofok',
      routes: siofokRoutes,
      ssrRoutes: siofokSsrRoutes,
      queueFairRoutes: siofokQueueFairRoutes,
      eventRoutePrefix: '/e/',
      businessRoutePrefix: '/b/',
    }
  ],
  [
    'embedded',
    {
      name: 'embedded',
      routes: embeddedRoutes,
      ssrRoutes: embeddedSsrRoutes,
      queueFairRoutes: embeddedQueueFairRoutes,
      eventRoutePrefix: '/e/',
      businessRoutePrefix: '/b/',
    }
  ],
]);

export function getActiveAppFlavor(): AppFlavor {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return flavors.get(environment.flavor)!;
}